// Remove controls from home page banner video
const homePageBanner = document.getElementById("shopify-section-template--19143827456232__video_with_text_VT4TRq");
if (homePageBanner) {
  const videos = homePageBanner.getElementsByClassName("video-with-text__video animation--video-with-text");
  if (videos.length > 0) {
    videos[0].removeAttribute("controls");
  }
}

// Pause videos with text
const videos = document.getElementsByClassName("video-with-text__video");
if (videos && videos.length > 0) {
  Array.prototype.forEach.call(videos, (v) => v.pause());
}